"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";

import config from "../../configs/app";
import useQueryClientConfig from "../../lib/api/useQueryClientConfig";
import { AppContextProvider } from "../../lib/contexts/app";
import { ChakraProvider } from "../../lib/contexts/chakra";
import { MarketplaceContextProvider } from "../../lib/contexts/marketplace";
import { ScrollDirectionProvider } from "../../lib/contexts/scrollDirection";
import { SettingsContextProvider } from "../../lib/contexts/settings";
import { SocketProvider } from "../../lib/socket/context";
import AppErrorBoundary from "src/components/error/AppErrorBoundary";
import AppErrorGlobalContainer from "src/components/error/AppErrorGlobalContainer";
import Web3ModalProvider from "src/components/providers/Web3ModalProvider";

interface ProvidersProps {
  children: React.ReactNode;
  cookies?: string;
}

export function Providers({ children, cookies }: ProvidersProps) {
  const queryClient = useQueryClientConfig();

  return (
    <>
      <ChakraProvider cookies={cookies}>
        <AppErrorBoundary
          Container={AppErrorGlobalContainer}
        >
          <Web3ModalProvider>
            <AppContextProvider pageProps={{}}>
              <QueryClientProvider client={queryClient}>
                <ScrollDirectionProvider>
                  <SocketProvider
                    url={ config.api.socket ? `${ config.api.socket }${ config.api.basePath }/socket/v2` : undefined }
                  >
                    <MarketplaceContextProvider>
                      <SettingsContextProvider>
                        {children}
                      </SettingsContextProvider>
                    </MarketplaceContextProvider>
                  </SocketProvider>
                </ScrollDirectionProvider>
                <ReactQueryDevtools
                  buttonPosition="bottom-left"
                  position="left"
                />
              </QueryClientProvider>
            </AppContextProvider>
          </Web3ModalProvider>
        </AppErrorBoundary>
      </ChakraProvider>
      {/* OpenGPU Footer */}
    </>
  );
}
